// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XQYh","content":"styles_content__d1nb2"};